import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiselectProjectLabels'
})
export class MultiselectProjectLabelsPipe implements PipeTransform {

  transform(options: any[]): string {
    return options.reduce((acc, option) => {
      const selectedOptions = Object.keys(option.value.selectedChildOptions).filter((childOptionKey) => {
       return option.value.selectedChildOptions[childOptionKey];
      });
      return option.value.childOptions.filter(childOption => !!selectedOptions.find(id => parseInt(id) === childOption.id))
                                .map(childOption => childOption.label)
                                .reduce((accLabel, label) => {
                                  return accLabel ? accLabel + ', ' + label : label
                                }, acc)
      }, '');
  }

}
